import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { STATES } from '../../constants';
import Select from '../Select/Select';
import { SELECT_OPTIONS_PROPTYPES } from '../Select/constants';

import './AuctionFilter.css';

const AuctionFilter = ({
    onLoad,
    shouldHideRegion,
    region,
    onRegionChange,
    categoryOptions,
    category,
    onCategoryChange,
    lockCategory,
    premiumOnly,
    onPremiumChange,
    onPremiumHover,
}) => {
    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
    }, []); // Run once on mount, like componentDidMount

    const showRegion = !shouldHideRegion;
    const showCategory = categoryOptions && !lockCategory;

    var handlePremiumToggle = function() {
        if (onPremiumChange) {
            onPremiumChange(premiumOnly ? null : 'y');
        }
    };

    // Prefetch premium results on hover for instant toggle
    var handlePremiumHover = function() {
        if (onPremiumHover && !premiumOnly) {
            onPremiumHover();
        }
    };

    return (
        <div className="al-filter-row">
            {showRegion && (
                <div className="al-filter-item">
                    <Select
                        options={STATES}
                        value={region}
                        onChange={onRegionChange}
                        unselectedText="Filter by region"
                    />
                </div>
            )}
            {showCategory && (
                <div className="al-filter-item">
                    <Select
                        options={categoryOptions}
                        value={category}
                        onChange={onCategoryChange}
                        unselectedText={
                            categoryOptions.length
                                ? 'Filter by category'
                                : 'Loading...'
                        }
                    />
                </div>
            )}
            {onPremiumChange && (
                <div className="al-filter-item al-filter-item--toggle">
                    <button
                        type="button"
                        className={'al-filter-toggle al-filter-toggle--premium' + (premiumOnly ? ' al-filter-toggle--active' : '')}
                        onClick={handlePremiumToggle}
                        onMouseEnter={handlePremiumHover}
                        onFocus={handlePremiumHover}
                        aria-pressed={!!premiumOnly}
                    >
                        <span className="al-filter-toggle-star">★</span>
                        <span>Premium</span>
                    </button>
                </div>
            )}
        </div>
    );
};

AuctionFilter.propTypes = {
    onLoad: PropTypes.func,
    isSidebar: PropTypes.bool,
    shouldHideRegion: PropTypes.bool,
    onRegionChange: PropTypes.func,
    region: PropTypes.string,
    onDateChange: PropTypes.func,
    date: PropTypes.string,
    categoryOptions: SELECT_OPTIONS_PROPTYPES,
    category: PropTypes.string,
    onCategoryChange: PropTypes.func,
    lockCategory: PropTypes.string,
    premiumOnly: PropTypes.string,
    onPremiumChange: PropTypes.func,
    onPremiumHover: PropTypes.func,
};

export default AuctionFilter;
